exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/_object-pie.js
// module id = 704
// module chunks = 32